import { FunctionComponent, useCallback } from 'react';
import { joinStrings } from '../../../../utils/string';
import { Button } from '../../../shared/Button';
import { Icon } from '../../../shared/Icon';
import { CookiesPreferencesMode } from '../types';
import { useCookiePreferencesContext } from '../CookiePreferences.context';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';
import './styles';

export type CookiesPreferenceFooterProps = {
  /**
   * Whether is component opened
   */
  isOpened?: boolean;
} & CookiesPreferencesMode;

export const CookiesPreferencesFooter: FunctionComponent<CookiesPreferenceFooterProps> = ({
  mode = 'prompt',
  isOpened = true,
}) => {
  const { t } = useTranslations();
  const {
    isAccepting,
    isRejecting,
    isSubmitting,
    isDetailPageDisplayed,
    setIsDetailPageDisplayed,
    setActiveCategory,
    onConfirm,
    onReject,
  } = useCookiePreferencesContext();

  const onBackBtnClick = useCallback((): void => {
    setIsDetailPageDisplayed(false);
    setActiveCategory('');
  }, [setIsDetailPageDisplayed]);

  return isOpened ? (
    <div
      className={joinStrings([
        'cookie-preference-footer__footer-btn',
        isDetailPageDisplayed && mode !== 'prompt' && 'cookie-preference-footer__footer-btn--hidden',
        isDetailPageDisplayed && 'cookie-preference-footer__footer-btn--space-between',
      ])}
    >
      {isDetailPageDisplayed && mode === 'prompt' && (
        <Button
          size="large"
          type="button"
          variant="text"
          iconPosition="left"
          icon={<Icon variant="ItvArrowLeft" />}
          onClick={onBackBtnClick}
        >
          {t('cookie-preferences-back-btn')}
        </Button>
      )}
      {!isDetailPageDisplayed && (
        <>
          <Button
            className="cookie-preference-footer__case"
            size="large"
            type="button"
            variant="secondary-alt"
            onClick={onReject}
            isSubmitting={isRejecting}
            disabled={isSubmitting || isAccepting}
          >
            {t('cookie-preferences-reject-btn')}
          </Button>
          <Button
            className="cookie-preference-footer__case"
            size="large"
            type="button"
            variant="primary"
            disabled={isRejecting || isAccepting}
            onClick={onConfirm}
            isSubmitting={isSubmitting}
          >
            {t('cookie-preferences-confirm-btn')}
          </Button>
        </>
      )}
    </div>
  ) : null;
};
